<script>
import LadSearchCommon from '@/components/pages/search/common'

export default {
  name: 'LadSearch',
  extends: LadSearchCommon,
}
</script>
